import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from '../shared/services/base.service';
import { Unidade } from '../models/unidade.model';
import { Observable } from 'rxjs';
import { Page } from '../models/page.model';

@Injectable({
  providedIn: 'root'
})
export class UnidadeService extends BaseService<Unidade> {

  constructor(protected injector: Injector) {
    super(`${environment.API_PRICE}/unidade`, injector);
  }

  getAllAtivos(): Observable<Page<Unidade>> {
    return this.http.get<Page<Unidade>>(`${environment.API_PRICE}/Unidade/getAllAtivos`)
  }
}